import React from 'react';

import {
  Create,
  SimpleForm,
  Toolbar,
  TextInput,
  SaveButton,
  required,
} from 'react-admin';

const CategoryCreateToolbar = () => {
  return (
    <Toolbar>
      <SaveButton />
    </Toolbar>
  );
};

export const CategoryCreate = () => {
  return (
    <Create redirect='list'>
      <SimpleForm toolbar={<CategoryCreateToolbar />}>
        <TextInput
          source="name"
          label="Category Name"
          validate={required()}
          fullWidth
        />
        <TextInput
          source="code"
          label="Category Code"
          validate={required()}
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
};
